import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// Pulled from <script>window.__INITIAL_DATA__ = {...}</script> embedded
// by src/ssr/render.ts. Used to seed ProductsContext so the client
// doesn't re-fetch /api/products on hydration when the server already
// embedded them.
declare global {
  interface Window {
    __INITIAL_DATA__?: { products?: unknown[]; activeCampaign?: unknown };
  }
}

const initialData = typeof window !== 'undefined' ? window.__INITIAL_DATA__ : undefined;

const root = document.getElementById('root')!;

const tree = (
  <StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <App initialData={initialData} />
      </HelmetProvider>
    </BrowserRouter>
  </StrictMode>
);

// If the server rendered the app, hydrate. Otherwise (dev / SSR fallback)
// create a fresh root. The SSR pipeline sets data-ssr="true" on #root to
// signal a hydration-friendly render is present.
if (root.hasAttribute('data-ssr')) {
  hydrateRoot(root, tree);
} else {
  createRoot(root).render(tree);
}
